@if (largeHeadingSize) {
<h3> Intended Usage of Short Code(s) </h3>
}
@else {
<h5> Intended Usage of Short Code(s) </h5>
}

<ng-content select="[blurb]"></ng-content>

<div class="row mb-4">
  <div>
    <p-radioButton [disabled]="!usagesEnabled.includes('active')" inputId='codeTypeActive' name="codeType" label="Active" value="active" [(ngModel)]="codeType" (click)="usagesEnabled.includes('active') && setCodeType()">
    </p-radioButton>
    <div [ngClass]="colWidth" class="ps-4">An Active Short Code is one that will be provisioned. For a short code to be active, 
      you must provide information about its intended use, including your messaging partners. This is the typical usage of a short code. When a short code is leased
      as an Active Short Code, it cannot be subsequently updated to be a Demo or Parked Short Code. In addition, if an Active Short Code is transferred, the Brand Client data
      does not transfer with that short code.</div>
  </div>
  <ng-content select="[brands]"></ng-content>
  <div class="mt-1">
    <p-radioButton [disabled]="!usagesEnabled.includes('demo')" inputId='codeTypeDemo' name="codeType" label="Demo" value="demo" [(ngModel)]="codeType" (click)="usagesEnabled.includes('demo') && setCodeType()"></p-radioButton>
    <div [ngClass]="colWidth" class="ps-4">
      <span>A Demo Short Code is one that may be used only for the limited purpose of promotional, marketing, or testing purposes. Associated Brand Clients cannot
        be selected for a Demo Short Code. When a short code is leased as a Demo Short Code, it cannot be subsequently updated to be a Parked Short Code, but can be
        updated to be an Active Short Code. In addition, Demo short codes cannot be transferred to another account. </span>
    </div>
  </div>
  <div class="mt-1">
    <p-radioButton [disabled]="!usagesEnabled.includes('parked')" inputId='codeTypeParked' name="codeType" label="Parked" value="parked" [(ngModel)]="codeType" (click)="usagesEnabled.includes('parked') && setCodeType()"></p-radioButton>
    <div [ngClass]="colWidth" class="ps-4">A Parked Short Code is one that does not yet have a designated Brand Client.
      Parked short codes cannot be provisioned until the Brand Client is identified and that information is provided. Parked short codes can be leased for a maximum
      of 6 months. After that, the intended usage must be updated to Active or Demo, or the short code must be relinquished. Parked short codes cannot be opted in
      to Auto-Renew, nor can they be transferred to another account. 
    </div>
  </div>
</div>